<template lang="pug">
  .b2b-table-usuarios
    //- Filtro Tabla Usuarios
    b2b-filters-usuarios(
      :filter-options='options')

    //- Tabla de Usuarios
    ods-table(
      :data='users.tableData',
      :start-sort='{ prop: "creationDateTime", order: "descending"}',
      style='width: 100%',
      @sort-change='orderOnServer',
      @cell-mouse-enter='handleCellMouseEnter',
      @selection-change='handleSelectionChange',
      highlight-current-row,
      size='small',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      ods-table-column(
        prop='username',
        :label='$t("users.users_entity_table.username")',
        :show-overflow-tooltip='true',
        v-if='isShowUsuario',
        sortable)
      ods-table-column(
        :label='$t("users.users_entity_table.complete_name")',
        :show-overflow-tooltip='true',
        v-if='isShowCompleteName',
        sortable)
        template(slot-scope='scope')
          <span>{{ scope.row.name }} {{ scope.row.firstSurname }} {{ scope.row.secondSurname }}</span>
      ods-table-column(
        prop='email',
        :label='$t("users.users_entity_table.email")',
        :show-overflow-tooltip='true',
        v-if='isShowEmail',
        sortable)
      ods-table-column(
        prop='creationDateTime',
        :label='$t("users.users_entity_table.creation_datetime")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowFechaAlta',
        :formatter='formatterDate',
        sortable)
      ods-table-column(
        prop='trial',
        :label='$t("users.users_entity_table.trail")',
        :show-overflow-tooltip='true',
        v-if='isShowNumeroIntentos',
        sortable)
      ods-table-column(
        prop='lastConnection',
        :label='$t("users.users_entity_table.last_connection_date")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowFechaUltimaConexion',
        :formatter='formatterDate',
        sortable)
      ods-table-column(
        prop='enable',
        :label='$t("users.users_entity_table.enable")',
        :show-overflow-tooltip='true',
        v-if='isShowActivo',
        sortable)
        template(slot-scope='scope')
          ods-switch(
            v-model='scope.row.enable',
            :active-color='primaryColor',
            inactive-color='#D5DCE0',
            @change='handleSetStatus(scope.row)')
      ods-table-column(
        label,
        :render-header='renderHeaderActions',
        width='80')
        template(slot-scope='scope')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.detail') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              @click='handleGoDetail(scope.row)')
              ods-icon(name='search', size='16')
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('user_detail.delete_user_tooltip') }}
            ods-button(
              v-if='canAdminUserAdvanced'
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral'
              @click='handleErase(scope.row)')
              ods-icon(name='delete', size='16')

    //- Paginación Tabla
    ods-row.b2b-table-usuarios__pagination(v-if='users.totalUsers > 0')
      ods-col.b2b-table-usuarios__pagination--right(:span='4')
        ods-tooltip(:content='$t("invoices.buttons.download_csv_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='mini',
            round='',
            icon='ods-icon-download'
            style='display:inline;'
            @click='handleDownloadAllCsv')
            | CSV
      ods-col.b2b-table-usuarios__pagination--right(:span='20')
        div.block(style='margin-bottom: 50px;')
          ods-pagination(
            ref='pagination',
            popper-class='b2b-pagination__dropdown',
            @size-change='handleSizeChange',
            @current-change='handleCurrentChangePagination',
            :current-page.sync='currentPage',
            :page-sizes='[20, 50, 100]',
            :page-size='20',
            layout='total, sizes, prev, pager, next, slot',
            :total='users.totalUsers')

      //- Usuarios Seleccionados
      transition(
        name='slide',
        mode='out-in')
        b2b-table-select-rows(
          v-if='multipleSelection.length',
          :total-select='multipleSelection.length')
          div(slot='actions')
            ods-button(
              icon='ods-icon-sync',
              size='small',
              circle,
              @click.native='resetMassive')
              | {{ $t('users.users_multiple_selection.massive_reset') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bFiltersUsuarios from '@/views/administracion/usuarios/B2bFiltersUsuarios'
import B2bTableMenuUsuarios from './B2bTableMenuUsuarios'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import filters from './filtros-usuarios'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-table-usuarios',
  mixins: [Utils],
  data () {
    return {
      // Tabla
      currentRow: {},
      multipleSelection: [],
      multipleSelectionIds: [],
      multipleSelectionUsername: [],
      // Paginación
      totalResults: 0,
      currentPage: 0
    }
  },

  computed: {
    ...mapGetters([
      'users',
      'queryUsers',
      'totalUsers',
      'isShowUsuario',
      'isShowCompleteName',
      'isShowFechaAlta',
      'isShowNumeroIntentos',
      'isShowActivo',
      'isShowEmail',
      'isShowFechaUltimaConexion',
      'isShowNumeroIdentificacion',
      'isShowEmail',
      'primaryColor',
      'getActiveLang',
      'canAdminUserAdvanced',
      'optionsFilterService'
    ])
  },

  components: {
    B2bFiltersUsuarios,
    B2bTableMenuUsuarios,
    B2bTableSelectRows
  },

  watch: {
    '$route' (to) {
      // this.users = this.users
    }
  },

  methods: {
    ...mapActions([
      'getUsers',
      'setStatusUser',
      'resetPasswordMassive',
      'queryUsersState',
      'listSelectedUsersState',
      'getOptionsService',
      'handleDownloadAllCsvUsers',
      'optionsServicesEnabledState',
      'deleteUser'
    ]),

    async orderOnServer ({ column, order, prop }) {
      let stringSort = ''
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.order_table')
      })

      if (order === 'descending') {
        order = 'DESC'
      } else if (order === 'ascending') {
        order = 'ASC'
      } else {
        order = 'desc'
      }

      if (!prop) {
        prop = 'creationDateTime'
      }

      stringSort = prop + ',' + order
      this.queryUsers.sort = stringSort

      try {
        await this.queryUsersState(this.queryUsers)
        dataQuery.query = this.queryUsers
        const users = await this.getUsers(dataQuery)
        this.totalResults = users.data.totalElements
      } catch (error) {
        console.log('orderOnServer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    handleSelectionChange (val) {
      this.multipleSelection = val

      if (val.length === 0) {
        this.multipleSelection = []
      }

      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
      this.multipleSelectionUsername = this.multipleSelection.map(item => item.username)
      console.log('this.multipleSelectionUsername: ', this.multipleSelectionUsername)
    },

    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },

    renderHeaderActions: h => {
      return <B2bTableMenuUsuarios />
    },

    // Tamaño Tabla (20,50,100)
    async handleSizeChange (val) {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.size_table')
      })
      this.queryUsers.size = val
      try {
        await this.queryUsersState(this.queryUsers)
        dataQuery.query = this.queryUsers

        const users = await this.getUsers(dataQuery)
        this.totalResults = users.data.totalElements
      } catch (error) {
        console.log('handleSizeChange CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Paginacion
    async handleCurrentChangePagination (val) {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.pagination_table')
      })
      this.queryUsers.page = val - 1
      try {
        await this.queryUsersState(this.queryUsers)
        dataQuery.query = this.queryUsers

        const users = await this.getUsers(dataQuery)
        this.totalResults = users.data.totalElements
      } catch (error) {
        console.log('handleCurrentChangePagination CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async handleSetStatus (user) {
      const data = {
        id: user.id,
        enable: user.enable
      }
      try {
        await this.setStatusUser(data)
      } catch (error) {
        console.log('setStatusUser CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    handleGoDetail () {
      sessionStorage.setItem('username', this.currentRow.username)

      router.push({
        name: 'usuario-detail',
        params: {
          userId: this.currentRow.id,
          username: this.currentRow.username
        }
      })
    },

    async handleDownloadAllCsv () {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_csv')
      })
      const params = this.queryUsers
      try {
        params.activeLang = this.getActiveLang
        const filename = await this.handleDownloadAllCsvUsers(params)
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadAllCsv CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async handleErase () {
      try {
        this.$confirm(this.$t('user_detail.confirm.message_delete_user'), {
          title: this.$t('user_detail.confirm.title_delete_user'),
          confirmButtonText: this.$t('user_detail.confirm.confirm_button_delete_user'),
          showCancelButton: false,
          center: true,
          iconClass: 'ods-icon-warning'
        }).then(async () => {
          await this.deleteUser(this.currentRow.id)
          // router.push({ name: 'usuarios-page' })
          this.$notify({
            title: this.$t('user_detail.notify.delete_user_ok'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
          const dataQuery = {
            query: {}
          }
          dataQuery.query = this.queryUsers
          const users = await this.getUsers(dataQuery)
          this.totalResults = users.data.totalElements
        }).catch((error) => { this.getNotificationErrorMessage(error) })
      } catch (error) {
        console.log('handleDeleteUser CATCH:: ' + error)
        this.getNotificationErrorMessage(error)
      }
    },

    async resetMassive () {
      const load = this.$loading({
        lock: true,
        text: this.$t('users.load.reset_password')
      })
      const paramsValues = this.multipleSelectionUsername.filter((item, index, self) => {
        return index === self.indexOf(item)
      })
      const dataQuery = {
        query: { username: paramsValues }
      }
      try {
        await this.resetPasswordMassive(dataQuery)
        this.$notify({
          title: this.$t('users.notify.reset_ok'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('resetMassive CATCH: ' + error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = this.$t('error.e400')
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 500:
          errorSms = this.$t('error.e500')
          break
        default:
          errorSms = this.$t('error.default')
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const dataQuery = {
      query: {}
    }
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    this.options = filters.filters
    try {
      if (this.optionsFilterService.length === 1) {
        this.queryUsers.projectId = this.optionsFilterService[0].id
      }
      dataQuery.query = this.queryUsers
      const users = await this.getUsers(dataQuery)
      this.totalResults = users.data.totalElements
      load.close()
    } catch (error) {
      console.log('getUsers CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-table-usuarios {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);

      .cell {
        font-weight: 500;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          .ods-dropdown {
            line-height: rem(32);
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: rem(32);
        }
      }
    }
    &__row{
      .ods-button {
        padding: rem(1) rem(15) rem(0) rem(15);
        margin-left: rem(0);
        margin-right: 0.2rem;
        i {
          margin-left: rem(0);
        }
      }
    }
  }

  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .ods-pagination {
        justify-content: flex-end;
        width: auto;
        padding-top: rem(0);
        float: right;
        &__label {
          padding-top: rem(0);
          float: right
        }
      }
    }
  }
}
</style>
